// "use client";

// import Image from "next/image";

// export default function MainFooter({ showBg = true, bgColor = '#050816' }) {
//     return (
//         <section className={`w-full md:pt-10 relative ${showBg ? `bg-[${bgColor}]` : 'bg-transparent'}`}>
//             {/* strip height like screenshot */}
//             {showBg && (
//                 <div
//                     className="absolute inset-0 bg-[url('/bg-new.png')] bg-cover bg-center bg-no-repeat z-0"
//                 />
//             )}
//             <div className="mx-auto w-full max-w-full md:max-w-6xl relative px-4 md:px-6 lg:px-8 xl:px-10  py-8 md:py-14  z-10">
//                 <div className="text-center">
//                     {/* logo */}
//                     <div className="mx-auto mb-6 flex justify-center">
//                         {/* replace with your real logo */}
//                         <div className="relative ">
//                             <img
//                                 className="w-[80px] h-[52px] md:w-[100px] md:h-[50px] lg:w-[140px] "
//                                 src={"/logo.svg"}
//                                 alt="GTCFX Logo"
//                             />
//                         </div>
//                     </div>

//                     {/* headline */}
//                     <h2 className="font-serif md:text-[34px] text-[18px] font-semibold leading-[1.05] text-white">
//                         Trade with Confidence. Anywhere.
//                     </h2>

//                     {/* sub line */}
//                     <p className="mt-5 font-serif md:text-[20px] text-[16px] leading-[1.2] text-white">
//                     © COPYRIGHT 2026 GTCFX
//                     </p>

//                     {/* rights */}
//                     <p className="mt-3 font-serif md:text-[18px] text-sm leading-[1.2] text-white">
//                     ALL RIGHTS RESERVED
//                     </p>
//                 </div>
//             </div>
//         </section>
//     );
// }



"use client";
import React from "react";
import Image from "next/image";
import { useLocale, useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { AiFillClockCircle } from "react-icons/ai";
import { usePathname } from "next/navigation";
import { useRouter } from "@/i18n/navigation";
import {
    BiLogoFacebookCircle,
    BiLogoYoutube,
    BiLogoLinkedinSquare,
    BiLogoInstagramAlt,
    BiLogoTelegram,
    BiLogoTiktok,
} from "react-icons/bi";
import { FaXTwitter } from "react-icons/fa6";


const Footer = () => {
    
    const pathname = usePathname();
    const router = useRouter();
    const locale = useLocale();
    const pathnameWithoutLocale = pathname.replace(`/${locale}`, "");

    // Add a check to see if the pathname is not the home page
    const isNotHomePage = pathname !== `/${locale}` && pathname !== "/";

    return (
        <>
            <div
                className={`pb-10 z-30 py-2 md:pt-14 xl:pt-16 md:pb-8 xl:pb-10 relative overflow-hidden ${isNotHomePage ? "mt-16" : ""
                    }`}
            >
                <div className="pointer-events-none absolute inset-0">
                    <img
                        src="/ab/overlay.webp"
                        alt=""
                        className="h-full w-full object-cover"
                        draggable={false}
                    />
                    {/* dark overlay + warm highlights like screenshot */}
                    <div className="absolute inset-0 bg-[radial-gradient(900px_520px_at_50%_12%,rgba(255,210,150,0.14),transparent_80%)]" />
                    <div className="absolute inset-0 bg-[radial-gradient(620px_520px_at_22%_30%,rgba(255,180,90,0.10),transparent_98%)]" />
                    <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.30)_0%,rgba(0,0,0,0.30)_38%,rgba(0,0,0,0.30)_100%)]" />
                </div>


                {/* Logo and App Download Section */}
                <div className="container mx-auto px-3 border-t border-white border-opacity-20 relative z-10">
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-2 md:gap-8 py-2 sm:py-2">
                        {/* Logo Section */}
                        <div className="flex flex-col items-center lg:items-start">
                            <Link href="/" locale={locale} aria-label="GTCFX">
                                <Image
                                    src="https://gtcfx-bucket.s3.ap-southeast-1.amazonaws.com/img/footer-logo.webp"
                                    width={150}
                                    height={53}
                                    alt="GTCFX official logo"
                                    className=""
                                    priority
                                />
                            </Link>
                        </div>

                        <div className="flex flex-row justify-center">
                            <a href="/privacy-policy" className="flex flex-col underline italic text-white">Terms & Condtions Apply</a>
                        </div>

                        {/* App Download Buttons */}
                        <div className="flex flex-row gap-4">
                            <a
                                href="https://apps.apple.com/ae/app/gtc-go/id6753007277"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center bg-gradient-to-r from-[#B68756] via-[#995F22] to-[#995F22] hover:from-[#263788] hover:via-[#101638] hover:to-[#263788] border border-white border-opacity-30 rounded-lg px-4 py-2 hover:opacity-90 transition-opacity"
                                aria-label="Download on the App Store"
                            >
                                <svg
                                    className="w-8 h-8 mr-2 text-white"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                                </svg>
                                <div className="text-left text-white">
                                    <div className="text-[10px] leading-tight">
                                        Download on the
                                    </div>
                                    <div className="text-sm font-semibold leading-tight">
                                        App Store
                                    </div>
                                </div>
                            </a>
                            <a
                                href="https://play.google.com/store/search?q=GTC%20Go&c=apps&hl=en"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center bg-gradient-to-r from-[#B68756] via-[#995F22] to-[#995F22] border border-white border-opacity-30 hover:from-[#263788] hover:via-[#101638] hover:to-[#263788]  rounded-lg px-4 py-2 hover:opacity-90 transition-opacity"
                                aria-label="Get it on Google Play"
                            >
                                <svg
                                    className="w-8 h-8 mr-2 text-white"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                                </svg>
                                <div className="text-left text-white">
                                    <div className="text-[10px] leading-tight">GET IT ON</div>
                                    <div className="text-sm font-semibold leading-tight">
                                        Google Play
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Disclaimers Section */}
                <div className="container mx-auto px-3 border-t border-white border-opacity-20 pt-8 relative z-10">
                    <div className="text-xs text-white text-opacity-70 space-y-3 leading-5">
                        <p>This website is owned and operated by GTC Global SA (Pty) Ltd, a private limited company incorporated in South Africa (Company Number: 2020/810937/07) and licensed by the Financial Sector Conduct Authority of South Africa (FSP No. 51545) to operate as an Intermediary. Registered Address: 18 Cavendish Road, Clarement, Cape Town, Western Cape, 7708, South Africa. The financial services and products promoted on this website are offered by GTC Global Trade Capital Co. Limited, a company authorised by the Vanuatu Financial Services Commission of the Republic of Vanuatu (Company License Number: 40354). Registered Address: 1/Floor, B&P House, Kumul Highway, Port Vila, Vanuatu.</p>
                        <p>
                            <span className="text-secondary pr-1">
                            GTC Global SA (Pty) Ltd and GTC Global Trade Capital Co. Limited
                            </span>
                            are part of the GTC Financial Group which comprises a network of entities across the globe.
                        </p>
                        <p>Investing in derivative products carries significant risks and may not be suitable for all investors. The use of leverage in these instruments can increase both the level of risk and potential for losses. Before making any decision to engage in foreign exchange trading or Contracts for Difference (CFDs), it is essential to carefully consider your investment objectives, level of experience, and risk tolerance. You should only invest funds that you can afford to lose. We strongly encourage you to educate yourself thoroughly on the associated risks and, if you have any questions, seek advice from an independent financial or tax advisor.</p>
                        <p>
                            <span className="text-secondary pr-1"> 
                            GTC Global SA (Pty) Ltd and GTC Global Trade Capital Co. Limited
                            </span>
                            do not provide services to individuals residing in specific jurisdictions and/or jurisdictions where distribution of such services would be contrary to local law or regulations.
                        </p>
                        <p>Each entity within the GTC Financial Group operates independently. The financial products and services offered on this website are provided SOLELY by GTC Global Trade Capital Co. Limited.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;
